module.exports = "/assets/js/9df2bcda915ddf9f2bd417c4151e63f4.svg";